// extracted by mini-css-extract-plugin
export var cardHeader = "_ki-1";
export var contentCard = "_ki-0";
export var headerActions = "_ki-3";
export var reorderHandle = "_ki-5";
export var titleArea = "_ki-2";
export var titleAreaWithHandle = "_ki-4";